;(function () {
  angular
    .module('contrast.notifications.settings.user')
    .controller('NotificationUserSettingsCtrl', NotificationUserSettingsCtrl)

  function NotificationUserSettingsCtrl(
    $scope,
    $translate,
    logger,
    $q,
    dialogs,
    notificationApiConfig,
    ApplicationFactory,
    notificationUserSettingsService,
    ErrorService,
    NOTIFICATION_TYPE,
    NOTIFICATION_CHANNELS,
    NOTIFICATION_TYPE_OPTIONS,
    ATTACK_STATUS,
    RULE_SEVERITY_LIST,
    SERVER_ENVIRONMENT,
    NOTIFICATION_ASSET_TYPE,
    permissions
  ) {
    'ngInject'

    var DB_CHANNEL = NOTIFICATION_CHANNELS.DATABASE,
      EMAIL_CHANNEL = NOTIFICATION_CHANNELS.EMAIL,
      ALL_OPTION = NOTIFICATION_TYPE_OPTIONS.ALL,
      DEFAULT_APP_OBJECT = { value: ALL_OPTION, name: 'All Applications' },
      DEFAULT_TRIGGER_OBJECT = { value: ALL_OPTION, name: 'All' }

    var channelTypeMap = {
      db: NOTIFICATION_CHANNELS.DATABASE,
      email: NOTIFICATION_CHANNELS.EMAIL
    }

    function init() {
      _loadApplications()
      _loadUserSettings()
    }

    var translGlobal = {
      title_attackStatusProbed: $translate.instant('title_attackStatusProbed'),
      title_attackStatusBlocked: $translate.instant(
        'title_attackStatusBlocked'
      ),
      title_attackStatusExploited: $translate.instant(
        'title_attackStatusExploited'
      ),
      title_attackStatusBlockedPerimeter: $translate.instant(
        'title_attackStatusBlockedPerimeter'
      ),
      title_attackStatusProbedPerimeter: $translate.instant(
        'title_attackStatusProbedPerimeter'
      ),
      title_attackStatusSuspicious: $translate.instant(
        'title_attackStatusSuspicious'
      )
    }

    //models
    angular.extend($scope, {
      settings: {
        activity_summary: { updating: false, enabled: false },
        apps: [],
        new_attack: {
          type: NOTIFICATION_TYPE.NEW_ATTACK,
          show_options: false,
          status: [],
          notify: { updating: false },
          db: { updating: false },
          email: { enabled: false, updating: false }
        },
        new_vulnerability: {
          type: NOTIFICATION_TYPE.NEW_VULNERABILITY,
          show_options: false,
          vulns_options: [],
          notify: { updating: false },
          db: { updating: false },
          email: { enabled: false, updating: false }
        },
        new_vulnerable_library: {
          type: NOTIFICATION_TYPE.NEW_VULNERABLE_LIBRARY,
          db: { updating: false },
          email: { enabled: false, updating: false }
        },
        server_offline: {
          type: NOTIFICATION_TYPE.SERVER_OFFLINE,
          db: { updating: false },
          email: { enabled: false, updating: false }
        },
        new_vulnerability_comment: {
          type: NOTIFICATION_TYPE.NEW_VULNERABILITY_COMMENT,
          db: { updating: false },
          email: { enabled: false, updating: false }
        },
        server_messages: {
          type: NOTIFICATION_TYPE.SERVER_MESSAGES,
          db: { updating: false },
          email: { enabled: false, updating: false }
        },
        new_asset: {
          type: NOTIFICATION_TYPE.NEW_ASSET,
          show_options: false,
          assets: [],
          db: { updating: false },
          email: { enabled: false, updating: false }
        },
        expiring_licenses: {
          type: NOTIFICATION_TYPE.EXPIRING_LICENSES,
          db: {
            channelKey: 'db',
            enabled: false,
            disabled: false,
            updating: false
          },
          email: {
            channelKey: 'email',
            enabled: false,
            disabled: false,
            updating: false
          }
        },
        sast_failed_scan: {
          type: NOTIFICATION_TYPE.SAST_FAILED_SCAN,
          db: {
            channelKey: 'db',
            enabled: false,
            disabled: false,
            updating: false
          },
          email: {
            channelKey: 'email',
            enabled: false,
            disabled: false,
            updating: false
          }
        }
      },
      mail_enabled: true,
      select: {
        attack_status: [
          {
            value: ATTACK_STATUS.EXPLOITED.value,
            name: translGlobal.title_attackStatusExploited
          },
          {
            value: ATTACK_STATUS.SUSPICIOUS.value,
            name: translGlobal.title_attackStatusSuspicious
          },
          {
            value: ATTACK_STATUS.BLOCKED_PERIMETER.value,
            name: translGlobal.title_attackStatusBlockedPerimeter
          },
          {
            value: ATTACK_STATUS.BLOCKED.value,
            name: translGlobal.title_attackStatusBlocked
          },
          {
            value: ATTACK_STATUS.PROBED_PERIMETER.value,
            name: translGlobal.title_attackStatusProbedPerimeter
          },
          {
            value: ATTACK_STATUS.PROBED.value,
            name: translGlobal.title_attackStatusProbed
          }
        ],
        vulns_options: [
          {
            value: RULE_SEVERITY_LIST[0].value,
            name: RULE_SEVERITY_LIST[0].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[1].value,
            name: RULE_SEVERITY_LIST[1].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[2].value,
            name: RULE_SEVERITY_LIST[2].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[3].value,
            name: RULE_SEVERITY_LIST[3].name,
            group: 'SEVERITY'
          },
          {
            value: RULE_SEVERITY_LIST[4].value,
            name: RULE_SEVERITY_LIST[4].name,
            group: 'SEVERITY'
          },
          {
            value: SERVER_ENVIRONMENT.DEVELOPMENT.value,
            name: SERVER_ENVIRONMENT.DEVELOPMENT.name,
            group: 'ENVIRONMENT'
          },
          {
            value: SERVER_ENVIRONMENT.QA.value,
            name: SERVER_ENVIRONMENT.QA.name,
            group: 'ENVIRONMENT'
          },
          {
            value: SERVER_ENVIRONMENT.PRODUCTION.value,
            name: SERVER_ENVIRONMENT.PRODUCTION.name,
            group: 'ENVIRONMENT'
          }
        ],
        assets: [
          { value: NOTIFICATION_ASSET_TYPE.APPLICATION },
          { value: NOTIFICATION_ASSET_TYPE.SERVER }
        ],
        applications: []
      }
    })

    angular.extend($scope, {
      isEOP: permissions.isEOP,
      updateTrigger: updateTrigger,
      cleanTrigger: cleanTrigger,
      updateChannel: updateChannel,
      updateChannelReact: updateChannelReact,
      showOptionsNewAttack: showOptionsNewAttack,
      showOptionsNewVuln: showOptionsNewVuln,
      showOptionsNewAsset: showOptionsNewAsset
    })

    //functions
    angular.extend($scope, {
      updateSettings: function () {
        $scope.settings.activity_summary.updating = true
        notificationApiConfig
          .updateUserSettings({
            activity_summary: $scope.settings.activity_summary.enabled
          })
          .then(function () {
            $scope.settings.activity_summary.updating = false
          })
          .catch(function (response) {
            ErrorService.processError(response)
            $scope.settings.activity_summary.enabled =
              !$scope.settings.activity_summary.enabled
          })
      },
      updateNotifyOnChange: function (trigger) {
        notificationApiConfig
          .updateUserNotificationNotifyOnChange(trigger.type, {
            notify_on_change: trigger.notify.enabled
          })
          .then(function () {
            trigger.notify.updating = false
          })
          .catch(function (response) {
            ErrorService.processError(response)
            trigger.notify.enabled = !trigger.notify.enabled
          })
      },
      updateSubscription: function (item, model) {
        var data = {}
        if (model.value === ALL_OPTION) {
          data.all_apps = true
        } else {
          data.application = model.value
        }

        notificationApiConfig
          .updateUserNotificationApplicationSubscription(data)
          .then(function (response) {
            logger.logSuccess(response.data.messages[0])

            //remove other options
            if (data.all_apps) {
              $scope.settings.apps = [DEFAULT_APP_OBJECT]
            } else {
              $scope.settings.apps = _removeAppAllOption($scope.settings.apps)
            }
          })
          .catch(function (response) {
            ErrorService.processError(response)
            $scope.settings.apps.splice(-1, 1)
          })
      },
      cleanSubscription: function (item, model) {
        var data = {}
        if (model.value === ALL_OPTION) {
          data.all_apps = false
        } else {
          data.application = model.value
        }

        notificationApiConfig
          .cleanUserNotificationApplicationSubscription(data)
          .then(function (response) {
            logger.logSuccess(response.data.messages[0])

            if ($scope.settings.apps.length == 0) {
              $scope.updateSubscription(DEFAULT_APP_OBJECT, DEFAULT_APP_OBJECT)
            }
          })
          .catch(function (response) {
            ErrorService.processError(response)
            $scope.settings.apps.push(item)
          })
      },
      restoreDefaults: function () {
        var transl = {
          title_restoreDefaultsDialog_restoreDefaults: $translate.instant(
            'title_restoreDefaultsDialog_restoreDefaults'
          ),
          detail_restoreDefaultsDialog_restoreDefaultsConfirmation:
            $translate.instant(
              'detail_restoreDefaultsDialog_restoreDefaultsConfirmation'
            ),
          action_restoreDefaultSettings: $translate.instant(
            'action_restoreDefaultSettings'
          ),
          action_cancel: $translate.instant('action_cancel')
        }

        dialogs
          .confirm(
            transl.title_restoreDefaultsDialog_restoreDefaults,
            transl.detail_restoreDefaultsDialog_restoreDefaultsConfirmation,
            {
              size: 'md-sm',
              yes: transl.action_restoreDefaultSettings,
              no: transl.action_cancel
            }
          )
          .result.then(function () {
            notificationApiConfig
              .restoreDefaults()
              .then(function (response) {
                logger.logSuccess(response.data.messages[0])
                _loadUserSettings()
              })
              .catch(ErrorService.processError)
          })
      }
    })

    function cleanTrigger(item, model, trigger) {
      var data = {}
      var type = trigger.type
      var autoSelectAll = false

      if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
        if (model === ALL_OPTION) {
          data.all_attack_status = false
        } else {
          data.attack_status = model
        }
        if ($scope.settings.new_attack.status.length == 0) {
          autoSelectAll = true
        }
      } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
        if (model.value === ALL_OPTION) {
          data.all_rule_severities = false
          data.all_server_environments = false
        } else if (item.group === 'SEVERITY') {
          data.rule_severity = model.value
        } else if (item.group === 'ENVIRONMENT') {
          data.server_environment = model.value
        }
        if ($scope.settings.new_vulnerability.vulns_options.length == 0) {
          autoSelectAll = true
        }
      } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
        if (model === ALL_OPTION) {
          data.all_asset_types = false
        } else {
          data.asset_type = model
        }
        if ($scope.settings.new_asset.assets.length == 0) {
          autoSelectAll = true
        }
      }

      notificationApiConfig
        .cleanUserNotificationType(type, data)
        .then(function (response) {
          logger.logSuccess(response.data.messages[0])
          if (autoSelectAll) {
            var option =
              type === NOTIFICATION_TYPE.NEW_VULNERABILITY
                ? DEFAULT_TRIGGER_OBJECT
                : ALL_OPTION
            $scope.updateTrigger(item, option, trigger)
          }
        })
        .catch(function (response) {
          ErrorService.processError(response)
          if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
            $scope.settings.new_attack.status.push(model)
          } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
            $scope.settings.new_vulnerability.vulns_options.push(model)
          } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
            $scope.settings.new_asset.assets.push(model)
          }
        })
    }

    function updateTrigger(item, model, trigger, itemsLength) {
      var data = {}
      var type = trigger.type
      if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
        if (model === ALL_OPTION || itemsLength == trigger.status.length) {
          data.all_attack_status = true
        } else {
          data.attack_status = model
        }
      } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
        if (model.value === ALL_OPTION) {
          data.all_rule_severities = true
          data.all_server_environments = true
        } else if (model.group === 'SEVERITY') {
          data.rule_severity = model.value
        } else if (model.group === 'ENVIRONMENT') {
          data.server_environment = model.value
        }
      } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
        if (model === ALL_OPTION) {
          data.all_asset_types = true
        } else {
          data.asset_type = model
        }
      }

      var dbData = { status: trigger.db.enabled }
      var emailData = { status: trigger.email.enabled }

      if (data.all_rule_severities && data.all_all_server_environments) {
        _updateTypeChannels(
          dbData,
          emailData,
          NOTIFICATION_TYPE.NEW_VULNERABILITY
        )
      }

      _updateTypeChannels(dbData, emailData, type)

      notificationApiConfig.updateUserNotificationType(type, data).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])

          if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
            if (data.all_attack_status) {
              trigger.status = [DEFAULT_TRIGGER_OBJECT]
            } else {
              trigger.status = _removeAllOption(trigger.status)
            }
          }

          if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
            if (data.all_rule_severities && data.all_server_environments) {
              trigger.vulns_options = [DEFAULT_TRIGGER_OBJECT]
            } else {
              var allOptionIndex = _.findIndex(
                trigger.vulns_options,
                function (x) {
                  return x.value === ALL_OPTION
                }
              )
              if (allOptionIndex != -1) {
                trigger.vulns_options = trigger.vulns_options
                  .slice(0, allOptionIndex)
                  .concat(
                    trigger.vulns_options.slice(
                      allOptionIndex + 1,
                      trigger.vulns_options.length
                    )
                  )
              }
            }
          }

          if (type === NOTIFICATION_TYPE.NEW_ASSET) {
            if (data.all_asset_types) {
              trigger.assets = [DEFAULT_TRIGGER_OBJECT]
            } else {
              trigger.assets = _removeAllOption(trigger.assets)
            }
          }
        },
        function (response) {
          ErrorService.processError(response)

          if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
            $scope.settings.new_attack.status.splice(-1, 1)
          } else if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
            $scope.settings.new_vulnerability.vulns_options.splice(-1, 1)
          } else if (type === NOTIFICATION_TYPE.NEW_ASSET) {
            $scope.settings.new_asset.assets.splice(-1, 1)
          }
        }
      )
    }

    function updateChannelReact(entry, channelKey) {
      // extra step before executing the same logic than in our legacy angular code
      entry[channelKey].enabled = !entry[channelKey].enabled

      // this is the call executed in our legacy angular code
      updateChannel(entry, channelKey)
    }

    function updateChannel(entry, channelKey) {
      var triggerType = entry.type
      var channelType = channelTypeMap[channelKey]
      var status = entry[channelKey].enabled
      entry[channelKey].updating = true
      var updatePromises = []

      var allItemIndex = _.findIndex(entry.vulns_options, function (item) {
        if (angular.isDefined(item.value)) {
          return item.value.toUpperCase() === NOTIFICATION_TYPE_OPTIONS.ALL
        } else {
          return false
        }
      })

      //Activate channel only if it fulfill one of these conditions:
      // * It is not new_vulnerability type
      // * if it has all option selected
      // * If it is changing from inactive to active
      // * It has an option selected
      if (
        triggerType !== 'new_vulnerability' ||
        allItemIndex !== -1 ||
        !entry.show_options ||
        _hasVulnerabilityOptionSelected(entry.vulns_options)
      ) {
        var notificationUpdatePromise =
          notificationApiConfig.updateUserNotificationChannel(
            triggerType,
            channelType,
            { status: status }
          )

        updatePromises.push(notificationUpdatePromise)
      }

      $q.all(updatePromises)
        .then(function () {
          entry.show_options = notificationUserSettingsService.showOptions(
            entry,
            $scope.mail_enabled
          )
          if (!entry.show_options) {
            _loadUserSettings()
          }
        })
        .catch(function (response) {
          ErrorService.processError(response)
          entry[channelKey].enabled = !entry[channelKey].enabled
        })
        .finally(function () {
          entry[channelKey].updating = false
        })
    }

    function _hasVulnerabilityOptionSelected(options) {
      return angular.isDefined(options) && options.length > 0
    }

    function showOptionsNewAttack() {
      return $scope.settings.new_attack.show_options
    }

    function showOptionsNewVuln() {
      return $scope.settings.new_vulnerability.show_options
    }

    function showOptionsNewAsset() {
      return $scope.settings.new_asset.show_options
    }

    function _loadApplications() {
      var data = { includeMerged: true, includeTrial: false }
      return ApplicationFactory.getApplicationsName(data)
        .then(function (response) {
          var apps = response.data.applications

          for (var i = 0; i < apps.length; i++) {
            var app = apps[i]
            $scope.select.applications.push({
              value: app.app_id,
              name: app.name
            })
          }
        })
        .catch(ErrorService.processError)
    }

    function _loadUserSettings() {
      $scope.settingsPromise = notificationApiConfig.getUserSettings().then(
        function (response) {
          var data = response.data
          notificationUserSettingsService.buildSettings($scope, data)
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _updateTypeChannels(dbData, emailData, notificationType) {
      $q.all([
        notificationApiConfig.updateUserNotificationChannel(
          notificationType,
          DB_CHANNEL,
          dbData
        ),
        notificationApiConfig.updateUserNotificationChannel(
          notificationType,
          EMAIL_CHANNEL,
          emailData
        )
      ]).catch(ErrorService.processError)
    }

    function _removeAppAllOption(array) {
      var index = _.findIndex(array, function (option) {
        return option.value == ALL_OPTION
      })

      if (index != -1) {
        array = array
          .slice(0, index)
          .concat(array.slice(index + 1, array.length))
      }
      return array
    }

    function _removeAllOption(array) {
      var index = _.indexOf(array, ALL_OPTION)
      if (index != -1) {
        array = array
          .slice(0, index)
          .concat(array.slice(index + 1, array.length))
      }
      return array
    }

    init()
  }
})()
